import * as React from 'react';
import { RichTextArea } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachRichText } from '../../hooks/use-bloomreach-rich-text.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';

/**
 * This variant of the Rich Text component is used on content pages
 */ const CmsRichTextDocument = ({ component  })=>{
    const { html  } = component.getModels();
    const { backgroundColor , textColor  } = component.getParameters();
    const richText = useBloomreachRichText(html);
    return /*#__PURE__*/ React.createElement("div", {
        className: "rich-text-wrapper",
        "data-t": "rich-text-wrapper"
    }, /*#__PURE__*/ React.createElement(RichTextArea, {
        content: richText,
        backgroundColor: backgroundColor,
        textColor: textColor
    }));
};
var CmsRichTextDocument$1 = compose(withBreakpointVisibility, withAnchor)(CmsRichTextDocument);

export { CmsRichTextDocument, CmsRichTextDocument$1 as default };
//# sourceMappingURL=RichTextDocument.js.map
